import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient) { }

  // Process Initial Subscription Payment
  processInitialSubscriptionPayment(data: any): Observable<any> {
    return this.http.post<any>(`/registration/processInitialSubscriptionPayment`, data);
  }

  // Register Organization
  registerOrganization(data: any): Observable<any> {
    return this.http.post<any>(`/registration/register`, data);
  }
}
